"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Separator", {
  enumerable: true,
  get: function get() {
    return _Separator.Separator;
  }
});

var _Separator = require("./Separator");